"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CallbackRequestLead = void 0;
var typeorm_1 = require("typeorm");
var CallbackRequestTypeOptions;
(function (CallbackRequestTypeOptions) {
  CallbackRequestTypeOptions["FLOATING_RIGHT_BUTTON"] = "FLOATING RIGHT BUTTON";
  CallbackRequestTypeOptions["COURSE_SECTION"] = "COURSE SECTION";
  CallbackRequestTypeOptions["PRICING_SECTION"] = "PRICING SECTION";
  CallbackRequestTypeOptions["DOWNLOAD_BROCHURE"] = "DOWNLOAD BROCHURE";
  CallbackRequestTypeOptions["FOOTER_CALLBACK"] = "FOOTER CALLBACK";
})(CallbackRequestTypeOptions || (CallbackRequestTypeOptions = {}));
var CallbackRequestLead = /** @class */function () {
  function CallbackRequestLead() {}
  __decorate([(0, typeorm_1.PrimaryGeneratedColumn)("uuid"), __metadata("design:type", String)], CallbackRequestLead.prototype, "id", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    type: "enum",
    enum: CallbackRequestTypeOptions
  }), __metadata("design:type", String)], CallbackRequestLead.prototype, "callbackRequestType", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], CallbackRequestLead.prototype, "name", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], CallbackRequestLead.prototype, "emailId", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], CallbackRequestLead.prototype, "phoneNumber", void 0);
  __decorate([(0, typeorm_1.CreateDateColumn)(), __metadata("design:type", Date)], CallbackRequestLead.prototype, "created_at", void 0);
  __decorate([(0, typeorm_1.UpdateDateColumn)(), __metadata("design:type", Date)], CallbackRequestLead.prototype, "updated_at", void 0);
  CallbackRequestLead = __decorate([(0, typeorm_1.Entity)()], CallbackRequestLead);
  return CallbackRequestLead;
}();
exports.CallbackRequestLead = CallbackRequestLead;